import * as React from "react"

import { explanationVideos } from "config/explanation-videos"
import { FlowAnswer, FlowVideoData, FlowVideos } from "types"
import VideoLarge from "components/VideoLarge"

export interface VideosProps {
  userAnswers: any
  videos: FlowVideos
}

const Videos: React.FC<VideosProps> = ({ userAnswers, videos }) => {
  const { trigger } = videos

  return Object.entries(videos.answerSpecificContent).map(
    ([answer, content]: [FlowAnswer, FlowVideoData]) => {
      const video = explanationVideos[content.videoId]
      const { directSourceUrl, title, poster } = video

      return (
        userAnswers[trigger]?.value.indexOf(answer) !== -1 && (
          <div key={`end-video-${trigger}-${answer}`}>
            <VideoLarge src={directSourceUrl} title={title} poster={poster} />
          </div>
        )
      )
    }
  )
}

export default Videos
